import styled from 'styled-components';
import {getSpacing} from '@tickchak/react-share/app';
import {dFlexColumn, alignCenter, dFlexCenter} from '../../../globalVariables/GlobalFlex';
import {DARK_GREEN2, LIGHT_GRAY5} from '../../../globalVariables/GlobalVariables';

export const buttonContainer = styled.div`
    ${dFlexColumn}
    ${alignCenter}
    gap: ${getSpacing('spaceSm')};
    margin-top: ${getSpacing('spaceMd')};
    width: 100%;
`;

export const linkButton = styled.div`
    color: ${DARK_GREEN2};
    font-size: var(--font-size-body, 16px);
    text-decoration: none;
    ${dFlexCenter}
    gap: 4px;
    cursor: default;
    font-weight: var(--font-weight-regular, 400);
    background: none;
    width: 100%;
    text-align: center;
    padding: ${getSpacing('spaceSm')} 0;
    border-top: 1px solid ${LIGHT_GRAY5};
`;
